export default {"src":"/_next/static/media/add.ae3bf2e9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};